/**
 * Created by mnaughton on 12/4/2015.
 */

import Field from "core/models/Field";
import ErrorUtils from "app/utils/ErrorUtils";

function sourceFactory(key, fieldAttributes) {
  return {
    key: key,
    loader: function (view, cb) {
      require(["app/models/" + key], function (ValueCollection) {
        var collection = new ValueCollection.default([]);

        collection.fetch({
          success: function () {
            cb(null, collection.models);
          },
          error: function (request, body) {
            cb(body.responseJSON);
          },
        });
      });
    },
    field: new Field(fieldAttributes),
  };
}

export default {
  User: sourceFactory("UserCollection", {
    label: "Name",
    id: "fullName",
    name: "fullName",
    editor: "link",
    editable: false,
    filterable: true,
    sortable: true,
  }),
  Group: sourceFactory("GroupCollection", {
    id: "name",
    name: "name",
    label: "Name",
    editor: "text",
  }),
  Organization: sourceFactory("OrganizationCollection", {
    id: "PrimaryName",
    name: "PrimaryName",
    label: "Name",
    editor: "text",
  }),
  Plugin: sourceFactory("PluginCollection", {
    id: "Name",
    name: "Name",
    label: "Name",
    editor: "text",
    sortable: true,
    filterable: true,
  }),
};



//////////////////
// WEBPACK FOOTER
// ./public/js/app/models/ValueCollections.js
// module id = 78
// module chunks = 1